import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import Layout from "../../layout/Layout";
import Movie from "../Movies";
import { Movies } from "./Data/MovieData";

const MoviesPage = () => {
  // setting a variable for the number of movies in a movie page per click using the loading more button
  const maxPage = 10;

  const [page, setPage] = useState(maxPage);

  const HandleLoad = () => {
    setPage(page + maxPage);
  };
  return (
    <Layout>
      <div className="min-height-screen container mx-auto px-2 my-6">
        {/* showing available number of movies */}
        <p className="text-lg font-medium my-6">
          Total <span className="font-bold text-subMain">{Movies?.length}</span>{" "}
          Movies Available
        </p>
        <div
          className="grid sm:mt-10 mt-6 xl:grid-cols-4 2xl:grid-cols-5 lg:grid-cols-3 sm:grid-cols-2 gap-6"
          data-aos="zoom-in"
        >
          {Movies.slice(0, page)?.map((movie, index) => (
            <Movie key={index} movie={movie} />
          ))}
        </div>
        {/* loading more movies */}

        <div className="w-full flex-colo md:my-20 my-10">
          <button
            onClick={HandleLoad}
            className="flex-rows gap-3 text-white py-3 px-6 rounded font-semibold border-2 border-subMain"
          >
            Loading More <CgSpinner className="animate-spin" />
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default MoviesPage;
